import {
  Button,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { Menu } from "@material-ui/icons";
import React, { useState, useContext, useEffect } from "react";
import FlexView from "react-flexview/lib";
import { Controller, useForm } from "react-hook-form";
import { STATES, STATE_EXPIRY_TTL } from "../../../../Constants";
import { ModificationContextStore } from "../../../../context/ModificationContext";
import SimpleAccordion from "../../../Core/Expansion/SimpleAccordion";
import { GreenButton } from "../../../Core/Buttons/GreenButton";
import NewButtonPopup from "../../../Core/Buttons/NewButtonPopup";
import LocalizationService from "../../../../services/LocalizationService";
import { FirebaseConfigKey, FirebaseService } from "../../../../services/FirebaseService";
import { EventEmitterService, EventKey } from "../../../../services/EventEmitterService";
import { UserApi } from "../../../../api/user.api";
import StorageService from "../../../../services/StorageService";
import { OptionalTag } from "../../../Core/OptionalTag";

const restrictedCountries = FirebaseService.getArray(FirebaseConfigKey.RESTRICTED_COUNTRIES)

export default ({ isRenewal, modificationObject, ...props }) => {
  const [states, setStates] = useState([])
  const { namedInsured } = modificationObject
  const {
    saveInsured,
    editInsured,
    insurance,
    isEditNamedInsured,
  } = useContext(ModificationContextStore);
  const [isOpen, setIsOpen] = useState(false);
  const {
    control,
    handleSubmit,
    register,
    errors,
    formState: { dirty },
  } = useForm({
    defaultValues: {
      first_name: modificationObject.namedInsured?.first_name,
      last_name: modificationObject.namedInsured?.last_name,
      address_line1: modificationObject.namedInsured?.address_line1,
      address_line2: modificationObject.namedInsured?.address_line2,
      city: modificationObject.namedInsured?.city,
      state: modificationObject.namedInsured?.state,
      zip: modificationObject.namedInsured?.zip,
      company_name: modificationObject.namedInsured?.company_name,
    },
  });

  useEffect(() => {
      const fetchData = async () => {
        const res = await UserApi.getStates()
      
        if(res.ok) {
            setStates(res.parsedData)
            StorageService.setWithExpiry('STATE_LIST', res.parsedData, STATE_EXPIRY_TTL)
        }
        else {
            EventEmitterService.dispatch(EventKey.ShowError, 'Failed to get states')
        }
    }
  
    if(StorageService.getWithExpiry('STATE_LIST')) {
        setStates(StorageService.getWithExpiry('STATE_LIST'))
    }
    else {
        fetchData()
    }
  },[]);

  const onSubmit = (data) => {
    saveInsured(data, isRenewal);
  };

  const validationEmptyField = (comment) => {
    return comment.trim() !== ''
}

  return (
    <SimpleAccordion
      onClick={() => setIsOpen(!isOpen)}
      isOpen={isOpen}
      className="margin-top-large"
      title={
        <FlexView column className="space-between full-width">
          <div>Insured Details </div>
          <div className="grey text-small">{`${namedInsured?.first_name} ${namedInsured?.last_name} / ${namedInsured?.address_line1} ${namedInsured?.address_line2 ?? ''} ${namedInsured?.city} ${namedInsured?.state} ${namedInsured?.zip}`}</div>
        </FlexView>
      }
      content={
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <div style={{ width: "100%" }}>
              <Grid container spacing="2">
                <Grid item sm="3" xs={12}>
                  <Controller
                    control={control}
                    name="first_name"
                    rules={{
                      required: 'Required',
                      validate: (value) => value.trim() !== '' || 'First Name cannot be empty',
                    }}
                    as={
                      <TextField
                        disabled={!isEditNamedInsured}
                        fullWidth
                        variant="outlined"
                        label="First Name"
                        error={!!errors.first_name}
                        helperText={errors.first_name ? errors.first_name.message : ''}
                      />
                    }
                  />
                </Grid>
                <Grid item sm="3" xs={12}>
                  <Controller
                    control={control}
                    name="last_name"
                    rules={{
                      required: 'Required',
                      validate: (value) => value.trim() !== '' || 'Last Name cannot be empty',
                    }}
                    as={
                      <TextField
                        disabled={!isEditNamedInsured}
                        fullWidth
                        variant="outlined"
                        error={!!errors.last_name}
                        helperText={errors.last_name ? errors.last_name.message : ''}
                        label="Last Name"
                      />
                    }
                  />
                </Grid>
                <Grid item sm="6" xs={12}>
                  <Controller
                    control={control}
                    name="company_name"
                    as={
                      <TextField
                        disabled={!isEditNamedInsured}
                        fullWidth
                        variant="outlined"
                        label="Company Name"
                        InputProps={{endAdornment: <InputAdornment position="end"><OptionalTag /> </InputAdornment>}}
                      />
                    }
                  />
                </Grid>
              </Grid>
              <Grid container className="margin-top-small margin-bottom-small">
                <Typography>Address</Typography>
              </Grid>
              <Grid container spacing="2">
                <Grid item sm="6"  xs={12}>
                  <Controller
                    control={control}
                    name="address_line1"
                    rules={{
                      required: 'Required',
                      validate: (value) => value.trim() !== '' || 'Address cannot be empty',
                    }}
                    as={
                      <TextField
                        disabled={!isEditNamedInsured}
                        fullWidth
                        variant="outlined"
                        label="Address Line 1"
                        error={!!errors.address_line1}
                        helperText={errors.address_line1 ? errors.address_line1.message : ''}
                      />
                    }
                  />
                </Grid>
                <Grid item sm="6" xs={12}>
                  <Controller
                    control={control}
                    name="address_line2"
                    as={
                      <TextField
                        disabled={!isEditNamedInsured}
                        fullWidth
                        variant="outlined"
                        label="Address Line 2"
                        InputProps={{endAdornment: <InputAdornment position="end"><OptionalTag /> </InputAdornment>}}
                      />
                    }
                  />
                </Grid>
                <Grid item sm="4" xs={12}>
                  <Controller
                    control={control}
                    name="city"
                    rules={{
                      required: 'Required',
                      validate: (value) => value.trim() !== '' || 'City cannot be empty',
                    }}
                    as={<TextField 
                      fullWidth disabled={!isEditNamedInsured} 
                      variant="outlined" 
                      label="City" 
                      error={!!errors.city}
                      helperText={errors.city ? errors.city.message : ''}
                      />}
                  />
                </Grid>
                <Grid item sm="4"  xs={12}>
                  <Controller
                    control={control}
                    name="state"
                    as={
                      <TextField
                        disabled={!isEditNamedInsured || !isRenewal}
                        fullWidth
                        variant="outlined"
                        select
                        label={ LocalizationService.STRINGS.state }
                      
                      >
                        {/* {states.map((state) => (
                          <MenuItem
                            key={state}
                            value={stateCodesDictionary[state]}
                          >
                            {state}
                          </MenuItem>
                        ))} */}
                        {[...states, ...restrictedCountries].sort((a,b) => a.name.localeCompare(b.name)).map(item => <MenuItem key={item.code} value={item.code}>{item.name}</MenuItem>)}
                      </TextField>
                    }
                  />
                </Grid>
                <Grid item sm="4" xs={12}>
                  <Controller
                    control={control}
                    name="zip"
                    rules={{
                      required: 'Required',
                      validate: (value) => value.trim() !== '' || 'Zip code cannot be empty',
                    }}
                    as={
                      <TextField
                        disabled={!isEditNamedInsured}
                        fullWidth
                        variant="outlined"
                        label="Zipcode"
                        error={!!errors.zip}
                        helperText={errors.zip ? errors.zip.message : ''}
                      />
                    }
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              {isEditNamedInsured ? (
                <NewButtonPopup type="submit" disabled={!dirty}>
                  Save changes
                </NewButtonPopup>
              ) : (
                <NewButtonPopup onClick={(e) => {
                  e.preventDefault();
                  editInsured()
                }}>Edit</NewButtonPopup>
              )}
            </div>
          </div>
        </form>
      }
    />
  );
};
